var React = require('react');

function SharefacebookhoverInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#0076ae","key":0}),React.createElement("path",{"d":"M19.7,8H17.45a3.75,3.75,0,0,0-3.75,3.75V14H11.45v3H13.7v6h3V17H19l.75-3h-3V11.75a.76.76,0,0,1,.75-.75H19.7Z","fill":"#fff","key":1})]);
}

SharefacebookhoverInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = SharefacebookhoverInline;

SharefacebookhoverInline.default = SharefacebookhoverInline;
